'use strict';function isObservable(value) {
    return false;
}
exports.isObservable = isObservable;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JzZXJ2YWJsZV9mYWNhZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhbmd1bGFyMi9zcmMvY29yZS9jaGFuZ2VfZGV0ZWN0aW9uL29ic2VydmFibGVfZmFjYWRlLnRzIl0sIm5hbWVzIjpbImlzT2JzZXJ2YWJsZSJdLCJtYXBwaW5ncyI6IkFBQUEsc0JBQTZCLEtBQVU7SUFDckNBLE1BQU1BLENBQUNBLEtBQUtBLENBQUNBO0FBQ2ZBLENBQUNBO0FBRmUsb0JBQVksZUFFM0IsQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBpc09ic2VydmFibGUodmFsdWU6IGFueSk6IGJvb2xlYW4ge1xuICByZXR1cm4gZmFsc2U7XG59Il19


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular2/src/core/change_detection/observable_facade.js
 ** module id = 267
 ** module chunks = 1
 **/